import { z } from 'zod';
/**
 * Actions (step 33 minimal framework for the action-button widget; PRD VS-071's
 * connector-declared actions and permissions are Phase 4). The API lists what it
 * can run and records every execution; the web labels actions by id through i18n
 * (`actions.<id>.name`), so no display string travels here.
 */
const IsoDate = z.iso.datetime({ offset: true });
export const BUILT_IN_ACTION_IDS = [
    'source.poll-now',
    'alerts.ack-all',
    'notifications.test-telegram',
];
export const ActionParamSchema = z.object({
    name: z.string().min(1).max(40),
    type: z.enum(['sourceId', 'string', 'number']),
    required: z.boolean(),
});
export const ActionSchema = z.object({
    id: z.string().min(1).max(80),
    params: z.array(ActionParamSchema),
    /** The UI asks before running it. */
    confirm: z.boolean(),
});
export const ActionListResponseSchema = z.object({ actions: z.array(ActionSchema) });
export const ExecuteActionRequestSchema = z.object({
    params: z.record(z.string(), z.unknown()).default({}),
});
/** One row of the audit log (`action_runs`); every execution writes one, whatever the outcome. */
export const ActionRunSchema = z.object({
    id: z.uuid(),
    actionId: z.string(),
    params: z.record(z.string(), z.unknown()),
    outcome: z.enum(['ok', 'error']),
    message: z.string().nullable(),
    at: IsoDate,
});
export const ActionRunListQuerySchema = z.object({
    limit: z.coerce.number().int().min(1).max(200).default(50),
});
export const ActionRunListResponseSchema = z.object({ runs: z.array(ActionRunSchema) });
//# sourceMappingURL=actions.js.map